import React, { useEffect } from "react"
import {UncontrolledInput as Input} from 'components/form';
import VMasker from "vanilla-masker";

function FormationDate(props) {
  const prefix = props.prefix || {
    name: "formation_date",
    id: "formation_date"
  }

  const validationFromMainEducationStatus = () => {
    const main_education_status = props.watch?.("main_education_status") || _.get(props.getValues?.(), "main_education_status");

    if (!main_education_status) return {};

    let date = new Date();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    
    if (main_education_status === "studying"){
      return {
        greatherThan: (value) => {
          let [monthValue, yearValue] = value.split("/").map(Number);

          if (yearValue < year) return false;
          if (yearValue === year && monthValue < month) return false;

          return true;
        }
      }
    } else if (main_education_status === "completed") {
      return {
        lessThan: (value) => {
          let [monthValue, yearValue] = value.split("/").map(Number);

          if (yearValue > year) return false;
          if (yearValue === year && monthValue > month) return false;

          return true;
        }
      }
    }

    return {};
  }

  const validation = {
    pattern: /([0][1-9]|[1][0-2])\/(19|20)\d{2}$/,
    validate: validationFromMainEducationStatus()
  };

  const messages = {
    pattern: "Não segue o padrão MM/AAAA ou não é uma data válida",
    greatherThan: "A data de formação deve ser maior ou igual ao mês e ano atual",
    lessThan: "A data de formação deve ser menor ou igual ao mês e ano atual"
  };

  useEffect(() => {
    VMasker(document.querySelector(".formation_date")).maskPattern("99/9999");
  }, []);
  
  return(
    <div className="form-group">
      <Input
        {...props}
        className="formation_date"
        placeholder="MM/AAAA"
        type="text"
        name={prefix.name}
        id={prefix.id}
        label={props.label || "Data de Formação"}
        validation={validation}
        messages={messages}
      />
    </div>
  )
}
export default FormationDate;
